import React from "react";
import NavAdmin from "../../nav-admin/nav-admin";
import DirectEmailIcon from "../../../assets/images/svg-icons-material-io/mail_lock_black_24dp.svg";
import useUserStore from "../../../utils/storeApp";

const HeaderWelcome = () => {
  const { userRole } = useUserStore((state) => ({
    userRole: state.userRole,
  }));
  return (
    <div className="HeaderWelcome">
      {userRole === "SES ADMINISTRATOR" || userRole === "ADMINISTRATOR" ? (
        <section>
          <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar">
            <div className="container w-max2">
              {/*Main Header*/}
              <div className="admin-title">
                <img
                  src={DirectEmailIcon}
                  className="filter-white"
                  alt="Secured email icon"
                />{" "}
                <span>DIRECT</span>
              </div>
              {/*Admin Menus*/}
              <NavAdmin />
            </div>
          </nav>
        </section>
      ) : null}
    </div>
  );
};

HeaderWelcome.defaultProps = {};

export default HeaderWelcome;
